import { AddIcon, CheckIcon, DeleteIcon, EditIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Stack,
  Textarea,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Select } from "chakra-react-select"

export default function EdgePropertiesModal({
  isOpen,
  onClose,
  edgeForm,
  onConnect,
  operations,
  nodes,
  edges,
  flowName,
}) {
  const { setValue, watch, handleSubmit, reset, formState } = edgeForm;
  const { edgeProperties, selectedEdge } = watch();

  const [isDisableNewFieldBtn, setIsDisableNewFieldBtn] = useState(true);
  const [variables, setVariables] = useState(edgeProperties?.variables || [
    {
      name: "",
      value: "",
      condition: "",
    },
  ]);

  const [selectedNameVariable, setSelectedNameVariable] = useState({});

  const [variableDisableList, setVariableDisableList] = useState({ 0: false });
  const [dataExtractionFields, setDataExtractionFields] = useState([]);
  const conditionOptions = [
    { value: "==", label: "==" },
    { value: ">=", label: ">=" },
    { value: "<=", label: "<=" },
    { value: "!=", label: "!=" },
  ];

  useEffect(() => {
    if (localStorage.getItem("dataExtractionFields")) {
      setDataExtractionFields(
        JSON.parse(localStorage.getItem("dataExtractionFields"))
      );
    }
  }, []);

  const handleClose = () => {
    reset({ edgeProperties: { name: "", type: "" }, selectedEdge: null });
    onClose();
  }

  const onSubmit = async (data) => {
    const type = "customEdge"
    selectedEdge
      ? await operations.onEditEdge(
          selectedEdge,
          data.edgeProperties,
          nodes,
          edges,
          flowName,
          type
        )
      : onConnect(
          data.params,
          data.edgeProperties,
          nodes,
          edges,
          flowName,
          type
        );
    handleClose();
  };

  const handleAddVariableField = (item, index) => {
    let newFields = [...variables];
    setVariableDisableList((prevState) => ({ ...prevState, [index]: true }));

    setValue("edgeProperties.variables", newFields);
    setIsDisableNewFieldBtn(false);
  };

  const handleVariableEdit = (item, index) => {
    setVariableDisableList((prevState) => ({ ...prevState, [index]: false }));
  };

  const handleDeleteVariableField = (item, index) => {
    let newFields = [...variables];
    newFields.splice(index, 1);
    setValue("edgeProperties.variables", newFields);
    setVariables(newFields);
  };

  return (
    <Modal size={"5xl"} isOpen={isOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edge Properties</ModalHeader>
        <ModalCloseButton />

        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <Stack spacing={4}>
              <FormControl>
                <FormLabel>Label</FormLabel>
                <Input
                  onChange={(e) =>
                    setValue("edgeProperties.name", e.target.value)
                  }
                  value={watch("edgeProperties.name")}
                />
              </FormControl>
              <RadioGroup
                onChange={(value) => setValue("edgeProperties.type", value)}
                value={edgeProperties?.type || ""}
              >
                <Stack direction="row">
                  <Tooltip label="Select this edge based on value of variable(s)">
                    <Box>
                      <Radio value="variables">Variables</Radio>
                    </Box>
                  </Tooltip>
                  <Tooltip label="Select this edge baed on description (selected with the help of LLM)">
                    <Box>
                      <Radio value="description">Description</Radio>
                    </Box>
                  </Tooltip>
                </Stack>
              </RadioGroup>

              {edgeProperties?.type === "description" && (
                <FormControl>
                  <FormLabel>Description</FormLabel>
                  <Textarea
                    onChange={(e) =>
                      setValue("edgeProperties.description", e.target.value)
                    }
                    value={watch("edgeProperties.description") || ""}
                  />
                </FormControl>
              )}

              {edgeProperties?.type === "variables" && (
                <>
                  <Flex>
                    <FormLabel>Add Variables</FormLabel>
                    <IconButton
                      isRound={true}
                      colorScheme="blue"
                      variant="outline"
                      aria-label="Add Field"
                      icon={<AddIcon />}
                      size={"xs"}
                      title={"Add new field"}
                      isDisabled={isDisableNewFieldBtn}
                      onClick={() => {
                        setIsDisableNewFieldBtn(true);
                        setVariables([
                          ...variables,
                          { name: "", value: "", condition: "" },
                        ]);
                        setVariableDisableList({
                          ...variableDisableList,
                          [variables.length]: false,
                        });
                      }}
                    />
                  </Flex>
                  {variables.map((item, index) => (
                    <Flex key={index} gap={2} alignItems={"center"}>
                      <Box width={"30%"}>
                        <Select
                          placeholder="Select Extracted Variable"
                          onChange={(selectedOption) => {
                            let data = [...variables];
                            data[index].name = selectedOption;
                            setVariables(data);
                            setSelectedNameVariable({ ...selectedNameVariable, [selectedOption.value]: selectedOption.label})
                          }}
                          options={dataExtractionFields?.map((option) => ({
                            value: option.id,
                            label: option.name,
                            isDisabled: selectedNameVariable[option?.id] ? true : false
                          }))}
                          value={item.name || {value: "", label: "Select Extracted Variable"}}
                          isDisabled={variableDisableList[index]}
                        />
                      </Box>
                      <Box width={"30%"}>
                        <Input
                          value={item.value}
                          onChange={(e) => {
                            let data = [...variables];
                            data[index].value = e.target.value;
                            setVariables(data);
                          }}
                          placeholder="Enter value"
                          isDisabled={variableDisableList[index]}
                        />
                      </Box>
                      <Box width={"30%"}>
                        <Select
                          placeholder="Select condition"
                          value={conditionOptions.find((option) => option.value === item.condition)}
                          onChange={(selectedOption) => {
                            let data = [...variables];
                            data[index].condition = selectedOption.value;
                            setVariables(data);
                          }}
                          options={conditionOptions}
                          isDisabled={variableDisableList[index]}
                        />
                      </Box>

                      <IconButton
                        isRound={true}
                        colorScheme="blue"
                        variant="outline"
                        aria-label="Add"
                        icon={<CheckIcon />}
                        size={"xs"}
                        title="Add"
                        ml={2}
                        isDisabled={variableDisableList[index]}
                        onClick={() => handleAddVariableField(item, index)}
                      />
                      <IconButton
                        isRound={true}
                        colorScheme="blue"
                        variant="outline"
                        aria-label="Edit"
                        icon={<EditIcon />}
                        size={"xs"}
                        title="Edit"
                        ml={2}
                        isDisabled={!variableDisableList[index]}
                        onClick={() => handleVariableEdit(item, index)}
                      />
                      <IconButton
                        isRound={true}
                        colorScheme="red"
                        variant="outline"
                        aria-label="Delete"
                        icon={<DeleteIcon />}
                        size={"xs"}
                        title="Delete"
                        ml={2}
                        onClick={() => handleDeleteVariableField(item, index)}
                        isDisabled={variables.length <= 1}
                      />
                    </Flex>
                  ))}
                </>
              )}
            </Stack>
          </ModalBody>
          <ModalFooter>
            <Button mr={3} onClick={handleClose}>
              Close
            </Button>
            <Button
              type="submit"
              colorScheme="blue"
              isLoading={formState.isSubmitting}
            >
              Submit
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
}
